import { render, staticRenderFns } from "./package-table-v2.vue?vue&type=template&id=56233bee&scoped=true&"
import script from "./package-table-v2.vue?vue&type=script&lang=js&"
export * from "./package-table-v2.vue?vue&type=script&lang=js&"
import style0 from "./package-table-v2.vue?vue&type=style&index=0&id=56233bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56233bee",
  null
  
)

export default component.exports